import { createAction } from '../libs/redux/saga'
export const ISLOGGED = "ISLOGGED";
export const FORGOT = "FORGOT";
export const LOGOUT = "LOGOUT";
export const LOGIN = "LOGIN";
//---------------------------------
export const DASHBOARD = "DASHBOARD";
export const ROLE = "ROLE";
export const USERROLE = "USERROLE";
export const PERMISSION = "PERMISSION";
export const SETTINGS = "SETTINGS";
export const USER = "USER";
export const ORDER = "ORDER";
export const LOAN_NUMBER = "LOAN_NUMBER";
export const LOANDUES = "LOANDUES";
export const PAYMENT = "PAYMENT";
export const ALLPAYMENT = "ALLPAYMENT";
export const ORDERCONFIRM = "ORDERCONFIRM";
export const RESEDOTP = "RESEDOTP";
export const RECEIPT = "RECEIPT";
export const OTPSUBMIT = "OTPSUBMIT";
export const MODULEDUES = "MODULEDUES";
export const REDIRECT = "REDIRECT";
export const TRANSACTIONLIST = "TRANSACTIONLIST";
export const REPORTS = "REPORTS";
export const OTPLOGIN = "OTPLOGIN";
export const OTPVERIFY = "OTPVERIFY";
export const LOAN_DETAILS = "LOAN_DETAILS";
export const PAYMENT_INITIATE = "PAYMENT_INITIATE";
export const PAYMENT_STATUS = "PAYMENT_STATUS";
export const TRANSACTION_HISTORY = "TRANSACTION_HISTORY";

export const REQUESTS = {
    ...createAction(LOGIN, "token", { loader: true }),
    ...createAction(LOGOUT, "token", {}),
    ...createAction(ISLOGGED, "token", {}),
    // ---  Do not update above code----
    ...createAction(DASHBOARD, "dashboard", {}),
    ...createAction(ROLE, "group", {}),
    ...createAction(USERROLE, "user/group", {}),
    ...createAction(PERMISSION, "permission", {}),
    ...createAction(SETTINGS, "settings", {}),
    ...createAction(FORGOT, "forgotpassword", {}),
    ...createAction(USER, "user", {}),
    ...createAction(ORDER, "orders", {}),
    ...createAction(LOAN_NUMBER, "loan/number", {}),
    ...createAction(LOANDUES, "loan/dues", {}),
    ...createAction(PAYMENT, "payments", {}),
    ...createAction(ALLPAYMENT, "all/payments", {}),
    ...createAction(ORDERCONFIRM, "loan/preview", {}),
    ...createAction(RESEDOTP, "loan/otp", {}),
    ...createAction(RECEIPT, "payment/timeline", {}),
    ...createAction(OTPSUBMIT, "loan/otp/verify", {}),
    ...createAction(MODULEDUES, "module/dues", {}),
    ...createAction(REDIRECT, "redirect", {}),

    ...createAction(REPORTS, "reports", {}),
    ...createAction(OTPLOGIN, "login", {}),
    ...createAction(OTPVERIFY, "verify-otp", {}),
    ...createAction(LOAN_DETAILS, "loan-details", {}),
    ...createAction(PAYMENT_INITIATE, "payment/initiate", {}),
  ...createAction(PAYMENT_STATUS, "payment/status",{}),
  ...createAction(TRANSACTION_HISTORY, "transaction_history",{}),

}
